import { Box, BoxProps } from '@chakra-ui/react';
import React from 'react';
import ReactQrCode, { QRCodeProps as ReactQRCodeProps } from 'react-qr-code';

export interface QRCodeProps extends BoxProps {
  downloadLink: string;
  qrCodeProps?: Omit<ReactQRCodeProps, 'value' | 'ref'>;
}

const QRCode = ({
  downloadLink,
  qrCodeProps = {},
  ...boxProps
}: QRCodeProps) => {
  return (
    <Box width="250px" height="250px" padding="15px" {...boxProps}>
      {downloadLink && (
        <ReactQrCode
          value={downloadLink}
          size={250}
          style={{ width: '100%', height: '100%' }}
          bgColor="var(--chakra-colors-neutral-0)"
          {...qrCodeProps}
        />
      )}
    </Box>
  );
};

export default QRCode;
